
export const getters = {
 systemUsers: state => state.users,
 User: state => state.systemUser,
}

export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/users/getters.js